import { Spin } from 'antd';

import { useEffect, ReactNode } from 'react';

import { useLocation } from 'react-router-dom';

import useStoreGlobal from 'src/hooks/useStoreGlobal';

import { ROUTES } from 'src/utils/constants/routes';

interface LoadingProps {
  children: ReactNode; // ✅ Properly typed children
}

function Loading({ children }: LoadingProps) {
  const storeGlobal = useStoreGlobal();

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === ROUTES.HOME) {
      document.body.classList.add('resize-body');
    } else {
      document.body.classList.remove('resize-body');
    }
  }, [location.pathname]);

  return (
    <Spin spinning={storeGlobal.isLoading} wrapperClassName="spinning-center">
      {children}
    </Spin>
  );
}

export { Loading };
